<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.location_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.location_form.form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.area_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>
        <form>
          <div class="form-row d-flex align-items-end">
            <div class="form-row align-items-center d-flex flex-row col-md-6">
              <div
                class="form-group col-md-6"
                @click="$refs.filePicker.click()"
              >
                <div class="tempPickerDiv">
                  <label for="logo">{{
                    $t("lang.location_form.labels.logo")
                  }}</label>
                  <img
                    style="height: 120px"
                    :src="input.logo"
                    v-if="input.logo"
                    class="img img-fluid"
                  />
                  <input
                    ref="filePicker"
                    @change="filePicked"
                    type="file"
                    style="display: none"
                    accept="image/*"
                  />
                </div>
              </div>
              <div
                class="select-box col-md-6 p-0"
                style="margin-top: 3.6rem !important"
              >
                <v-select
                  :items="brands"
                  item-text="description"
                  v-model="input.brand_id"
                  item-value="id"
                  :label="$t('lang.location_form.labels.brand')"
                  outlined
                ></v-select>
              </div>
            </div>
            <div class="col-md-6 ms-5">
              <v-text-field
                :label="$t('lang.location_form.labels.name')"
                outlined
                v-model="input.description"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.location_form.labels.phone')"
                outlined
                v-model="input.phone_name"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.location_form.labels.email')"
                outlined
                type="email"
                v-model="input.email"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.location_form.labels.street_name')"
                outlined
                v-model="input.street_name"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.location_form.labels.street_num')"
                outlined
                v-model="input.street_num"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <v-text-field
                :label="$t('lang.location_form.labels.city')"
                outlined
                v-model="input.city"
              ></v-text-field>
            </div>
            <div class="col-md-4">
              <v-text-field
                :label="$t('lang.location_form.labels.cp')"
                outlined
                v-model="input.postal_code"
              ></v-text-field>
            </div>
            <div class="select-box col-md-4">
              <v-select
                :items="countries"
                item-text="country"
                v-model="input.country"
                item-value="country"
                :label="$t('lang.location_form.labels.country')"
                outlined
              ></v-select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12">
              <v-textarea
                :label="$t('lang.location_form.labels.observations')"
                outlined
                v-model="input.observations"
              ></v-textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn text rounded type="reset" @click="$router.back()">{{
                $t("lang.location_form.btn_cancel")
              }}</v-btn>
              <bx-btn color="primary" @click="submitForm">{{
                $t("lang.location_form.btn_done")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
let Input = () => {
  return {
    logo: null,
    description: null,
    brand_id: 1,
    street_name: null,
    street_num: null,
    floor: "1",
    city: null,
    postal_code: null,
    country: null,
    phone_name: null,
    email: null,
    observations: null
  };
};

export default {
  name: "AddLocationForm",
  data() {
    return {
      input: new Input(),
      errors: [],
      countries: [],
      brands: [],
      success: {
        show: false,
        message: this.$t("lang.location_form.success_add")
      },
      errorLabels: {
        description: this.$t("lang.location_form.errors.description"),
        street_name: this.$t("lang.location_form.errors.street_name"),
        street_number: this.$t("lang.location_form.errors.street_number"),
        city: this.$t("lang.location_form.errors.city"),
        postal_code: this.$t("lang.location_form.errors.postal_code"),
        country: this.$t("lang.location_form.errors.country"),
        brnad: this.$t("lang.location_form.errors.brnad"),
        failed: this.$t("lang.location_form.errors.failed")
      }
    };
  },
  async mounted() {
    this.countries = await this.$api.common.getCountries();
    this.brands = await this.$api.location.getBrands();
  },
  methods: {
    async submitForm() {
      let input = Object.assign({}, this.input);

      if (this.validate()) {
        delete input.logo;
        delete input.observations;
        delete input.email;
        delete input.phone_name;

        input.postal_code = parseInt(input.postal_code);
        input.street_num = parseInt(input.street_num);

        try {
          // let response = await this.$api.location.addLocation(input);

          this.success.show = true;
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
          console.error(error);
        } finally {
          this.input = new Input();
        }
      }
    },
    validate() {
      this.errors = [];
      let error = false;
      this.success.show = false;

      if (!this.input.description) {
        error = true;
        this.errors.push(this.errorLabels.description);
      }

      if (!this.input.street_name) {
        error = true;
        this.errors.push(this.errorLabels.street_name);
      }

      if (!this.input.street_num) {
        error = true;
        this.errors.push(this.errorLabels.street_number);
      }

      if (!this.input.city) {
        error = true;
        this.errors.push(this.errorLabels.city);
      }

      if (!this.input.postal_code) {
        error = true;
        this.errors.push(this.errorLabels.postal_code);
      }

      if (!this.input.country) {
        error = true;
        this.errors.push(this.errorLabels.country);
      }

      if (!this.input.brand_id) {
        error = true;
        this.errors.push(this.errorLabels.brand);
      }

      if (error) {
        return false;
      }

      return true;
    },
    filePicked(files) {
      let self = this;
      if (files && files.srcElement.files) {
        var reader = new FileReader();

        reader.onload = function(e) {
          self.input.logo = e.target.result;
        };

        reader.readAsDataURL(files.srcElement.files[0]);
      }
    }
  }
};
</script>

<style>
.tempPickerDiv {
  height: 120px;
  width: 100%;
  border: 1px solid #000;
  border-radius: 5px;
  cursor: pointer;
}
</style>
